import { render, staticRenderFns } from "./ApartmentPrice.vue?vue&type=template&id=54511473&scoped=true"
import script from "./ApartmentPrice.vue?vue&type=script&lang=js"
export * from "./ApartmentPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54511473",
  null
  
)

export default component.exports